import { OpStatus, LanePollData } from "NSwag/ServerClient/Client.nswag";

type IIconMap = Map<OpStatus, Function>;

/**
 * Maps all detector OpStatus values to a function
 * to generate the color for an associated lane
 */
const laneColorFunctionMapping: IIconMap = new Map<OpStatus, Function>([
    [OpStatus.NULL, () => UnknownColor],
    [OpStatus.NotSet, () => '#00000044'],
    [OpStatus.Active, (speedLimit: number, laneSpeed: number) => calculateLaneColorFromSpeed(speedLimit, laneSpeed)],
    [OpStatus.Error, (speedLimit: number, laneSpeed: number) => calculateLaneColorFromSpeed(speedLimit, laneSpeed)],
    [OpStatus.Failed, (speedLimit: number, laneSpeed: number) => calculateLaneColorFromSpeed(speedLimit, laneSpeed)],
    [OpStatus.OutOfService, () => '#00000044']
]);

/**
 * Calculates the color to use for a lane based on the detectorOpStatus,
 * link speed limit, and the lanes current poll data
 * @param {any} opStatus
 */
export const GetLaneColor = (detectorOpStatus: OpStatus, speedLimit: number, lanePollData: LanePollData) => {

    let color: string | null = null;

    if (lanePollData) {

        let laneSpeed: number | null = null;
        if (lanePollData.smoothedData && lanePollData.smoothedData.speed) {
            laneSpeed = lanePollData.smoothedData!.speed!;
        }

        let colorFunc: Function | undefined = laneColorFunctionMapping.get(detectorOpStatus);
        if (colorFunc) {
            color = colorFunc(speedLimit, laneSpeed);
        }
    }

    if (!color) {
        color = UnknownColor;
    }

    return color;
}

const UnknownColor = '#00000044';

/**
 * Maps a threshold description to a color
 */
const enum laneColorsByThreshold{
    // Current speed >= 70% speed limit
    AboveThreshold = '#84CA50',
    // Current speed >= 50% && < 70%
    BetweenThresholds = '#F07D02',
    // Current speed >= 30% && < 50%
    NearingThreshold = '#E60000',
    // Current speed < 30%
    BelowThreshold = '#9E1313'
}

/**
 * Caclulates a lanes color based on its current speed
 * compared to the links speed limit
 * @param {any} speedLimit
 * @param {any} laneSpeed
 */
const calculateLaneColorFromSpeed = (speedLimit: number, laneSpeed: number) => {
    let percentOfSpeedLimit = laneSpeed * 1.0 / speedLimit;
    let color: string | null = null;

    if (percentOfSpeedLimit >= .7) {
        color = laneColorsByThreshold.AboveThreshold;
    } else if (percentOfSpeedLimit >= .5 && percentOfSpeedLimit < .7) {
        color = laneColorsByThreshold.BetweenThresholds;
    } else if (percentOfSpeedLimit >= .3 && percentOfSpeedLimit < .5) {
        color = laneColorsByThreshold.NearingThreshold;
    } else if (percentOfSpeedLimit < .3) {
        color = laneColorsByThreshold.BelowThreshold;
    }

    return color;
}